import {
    Component,
    Output,
    Input,
    EventEmitter,
    OnChanges,
    AfterViewInit,
    SimpleChange,
    ChangeDetectionStrategy,
    NgZone,
    ElementRef,
    ViewChild,
    Renderer
} from '@angular/core';
import { InventoryTreeHolder } from '../tree-holder/inventory-tree-holder.component';
import { TreeService, TreeNode } from '../../../../../common/tree';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Component({
    selector: 'tree-vc',
    template: `
       <div>
        <inventory-tree-holder #treeview [url]="url" [state]="state" [actionsMap]="menuActionMapping" [linksMap]="menuLinksMapping" autofocus></inventory-tree-holder>
      </div>
    `
})
export class InventoryTreeVC implements AfterViewInit {
    @Input() state: any;
    show: boolean;
    @Output() onShow = new EventEmitter();
    @ViewChild('treeview') treeView: InventoryTreeHolder;
    url: String;
    menuActionMapping: any;
    menuLinksMapping: any;
    constructor(private element: ElementRef,
                private renderer: Renderer, private ngZone: NgZone) {
        this.show = true;
        this.url = '/hybridity/api/vctree';
        this.menuActionMapping = {
            'Edit Resource Pool':
                (tree: TreeService, node: TreeNode) => { alert('Edit Resource Pool'); },
            'Delete Resource Pool':
                (tree: TreeService, node: TreeNode) => { alert('Delete Resource Pool'); },
            'Edit Virtual Machine':
                (tree: TreeService, node: TreeNode) => { alert('Edit Virtual Machine'); },
            'Delete Virtaul Machinbe':
                (tree: TreeService, node: TreeNode) => { alert('Delete Virtual Machine'); }
        };
        this.menuLinksMapping = {
            'RESOURCE_POOL': [
                { title: 'Edit Resource Pool' },
                { title: 'Delete Resource Pool' }
            ],
            'VM': [
                { title: 'Edit Virtual Machine' },
                { title: 'Delete Virtual Machine' }
            ]
        };
    }

    ngOnInit() {
        this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
    }

    ngAfterViewInit() {
        // TODO Find the first root node and preselect
    }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        // TODO - Capture state changes and set child components
    }

    toggleState() {
        this.show = !this.show;
        if (this.show) {
            this.onShow.emit(this.show);
            this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-tree/vc/inventory-tree-vc.component.ts